import { render, staticRenderFns } from "./WsStateDropdownCheckboxInputAvatar001.vue?vue&type=template&id=8bb5cc88"
import script from "./WsStateDropdownCheckboxInputAvatar001.vue?vue&type=script&lang=js"
export * from "./WsStateDropdownCheckboxInputAvatar001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports